import React, {Component} from "react";
import {Button, TextField} from "@material-ui/core";
import classes from './ContactForm.module.css';
import * as actions from "../../../store/actions";
import {connect} from "react-redux";

class ContactForm extends Component {
	state = {
		name: '',
		email: '',
		subject: '',
		message: '',
		formValid: false
	}
	handleFormSubmit = (event) => {
		event.preventDefault();
		let subject = this.state.subject;
		let content = "Name: " + this.state.name;
		content += "<br /> Subject: " + this.state.subject;
		content += "<br /> Email: " + this.state.email;
		content += "<br /> Message: " + this.state.message;
		content = "<html>" + content + "</html>";
		this.props.submitContactRequest(subject, content);
		this.setState({
			name: '',
			email: '',
			message: '',
			subject: ''
		})
	};
	checkValidity = () => {
		this.setState({
			formValid: this.state.subject && this.state.email && this.state.name && this.state.message
		})
	}
	handleNameChange = (event) => {
		this.setState({
			name: event.target.value
		})
		this.checkValidity();
	};

	handleSubjectChange = (event) => {
		this.setState({
			subject: event.target.value
		})
		this.checkValidity();
	};
	handleEmailChange = (event) => {
		this.setState({
			email: event.target.value
		})
		this.checkValidity();
	};
	handleMessageChange = (event) => {
		this.setState({
			message: event.target.value
		})
		this.checkValidity();
	};

	render() {
		return (
			<div>
				<h2>
					How can I <span className={classes.Help}>Help You?</span>
				</h2>
				<form onSubmit={this.handleFormSubmit} noValidate>
					<div style={{textAlign: 'center', padding: '10px'}}>
						<div style={{textAlign: 'center'}}>
							{this.props.successMessage ? <div style={{color: 'green'}}>{this.props.successMessage}</div> : null}
							{this.props.errorMessage ? <div style={{color: 'red'}}>{this.props.errorMessage}</div> : null}
						</div>
						<TextField
							id="subject"
							label="Subject"
							value={this.state.subject}
							onChange={this.handleSubjectChange}
							fullWidth={true}
							required/>
						<TextField
							id="full-name"
							label="Full Name"
							value={this.state.name}
							onChange={this.handleNameChange}
							fullWidth={true}
							required/>
						<TextField
							id="email-id"
							label="Email Address"
							value={this.state.email}
							onChange={this.handleEmailChange}
							fullWidth={true}
							required/>
						<TextField
							id="message"
							label="Message"
							value={this.state.message}
							onChange={this.handleMessageChange}
							fullWidth={true}
							required/>
							<div style={{margin: '30px 0'}}>
								<Button
									variant="contained"
									type={"submit"}
									className={classes.SubmitButton}
									disabled={this.props.loading || !this.state.formValid}
								>
									{this.props.loading ? "Sending Message...": "Send Message"}
								</Button>
							</div>
					</div>
				</form>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		loading: state.root.loading,
		successMessage: state.root.successMessage,
		errorMessage: state.root.errorMessage
	}
};
const mapDispatchToProps = dispatch => {
	return {
		submitContactRequest:
			(subject, content) => dispatch( actions.submitContactRequest(subject, content) )
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
